
import Home from './components/Home';
import ReactDOM from 'react-dom/client';
import Faqs from './components/public/Faqs';
import NotFound from './components/NotFound';
import Landing from './components/public/Landing';
import Support from './components/support/Support';
import SearchResult from './components/SearchResult';
import ContactUs from './components/public/ContactUs';
import Resources from './components/public/Resources';
import Communities from './components/public/Communities';
import SupportArticle from './components/public/SupportArticle';
import SupportCategory from './components/public/SupportCategory';
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { LocalStorageFeatureFlagSource, OyaGbewa, SessionStorageFeatureFlagSource, UrlSearchParamsFeatureFlagSource } from "@syllektis/oya-gbewa-react";
import './assets/css/index.css';
import './assets/css/scheme.css';

OyaGbewa.initFeatureFlags({
    environment: "production",
    sources: [
        SessionStorageFeatureFlagSource.getInstance({ ignoreEvents: true }),
        LocalStorageFeatureFlagSource.getInstance({ injectSameWindowEventTrigger: true }),
        UrlSearchParamsFeatureFlagSource.getInstance({ key: "featureFlags", emptyStringIsBoolean: true }),
    ]
});

const router = createBrowserRouter([
    { path: "/", element: (<Home />) },
    { path: "/:platform", element: <Landing /> },
    { path: "/:platform/faqs", element: <Faqs /> },
    { path: "/:platform/*", element: <NotFound /> },
    { path: "/:platform/support/*", element: <Support /> },
    { path: "/:platform/resources", element: <Resources /> },
    { path: "/:platform/search", element: <SearchResult /> },
    { path: "/:platform/contact-us", element: <ContactUs /> },
    { path: "/:platform/communities", element: <Communities /> },
    { path: "/:platform/article/:id", element: <SupportArticle /> },
    { path: "/:platform/category/:id", element: <SupportCategory /> },
]);

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    //<React.StrictMode>
    <RouterProvider router={router} />
    //</React.StrictMode>
);

